import eventemitter3 from 'eventemitter3';

export const GlobalEventEmitter = new eventemitter3();
